// import axiosInstance from '../../config';

// export const adminSendRequestService = async (data, token) => {
//     try {
//         const response = await axiosInstance.post(
//             '/copier/send_copier_request',
//             data,
//             {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Content-Type': 'application/json',
//                 },
//             }
//         );


//         return {
//             success: true,
//             data: response.data,
//             status: response.status,
//         };
//     } catch (error) {
//       
//        
//          // Optional for debugging

//         return {
//             success: false,
//             message: error.response?.data?.message || 'Send Request failed',
//             status: error.response?.status || 500,
//             errors: error.response?.data?.errors || null,
//         };
//     }
// };


import axiosInstance from '../../config';

export const adminSendRequestService = async (data, token) => {

    try {

        const response = await axiosInstance.post(

            '/copier/send_copier_request',

            data,

            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },

            }

        );



        return {

            success: true,

            data: response.data,

            status: response.status,

        };

    }
    catch (error) {



        // Optional for debugging

        return {

            success: false,

            message: error.response?.data?.message || 'Send Request failed',

            status: error.response?.status || 500,

            errors: error.response?.data?.errors || null,

        };

    }

};